import type { Controller } from "../lifecycle";

export class PromptArchiveController implements Controller {
  private button?: HTMLButtonElement;
  private source?: HTMLTextAreaElement;
  private label?: HTMLElement;
  private status?: HTMLElement;

  private readonly copy = async (): Promise<void> => {
    if (!this.source) return;
    let copied = false;

    try {
      await navigator.clipboard.writeText(this.source.value);
      copied = true;
    } catch {
      this.source.focus();
      this.source.select();
      copied = document.execCommand("copy");
      window.getSelection()?.removeAllRanges();
    }

    if (this.label) this.label.textContent = copied ? "Copied" : "Select prompt";
    if (this.status) {
      this.status.textContent = copied
        ? "Reconstruction prompt copied to the clipboard."
        : "Clipboard access is unavailable. The prompt is selected for manual copying.";
    }

    window.setTimeout(() => {
      if (this.label) this.label.textContent = "Copy prompt";
    }, 1800);
  };

  mount(root: ParentNode): void {
    this.button =
      root.querySelector<HTMLButtonElement>("[data-copy-prompt]") ?? undefined;
    this.source =
      root.querySelector<HTMLTextAreaElement>("[data-prompt-source]") ?? undefined;
    this.label =
      root.querySelector<HTMLElement>("[data-copy-label]") ?? undefined;
    this.status =
      root.querySelector<HTMLElement>("[data-copy-status]") ?? undefined;
    this.button?.addEventListener("click", this.copy);
  }

  destroy(): void {
    this.button?.removeEventListener("click", this.copy);
    this.button = undefined;
    this.source = undefined;
    this.label = undefined;
    this.status = undefined;
  }
}
